// extracted by mini-css-extract-plugin
export default {"main":"WhiteMainBackground_main__t-F1z"};